export default __webpack_public_path__ + "static/media/money-coming.4bbc6db4.svg";